import { Component } from "@angular/core";

@Component({
  selector: "app-logo-cnet",
  templateUrl: "logo-cnet.component.html",
})
export class LogoCnetComponent {}
